export default function AttachRecommendationDocumentController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Document Added';
  vm.isExpanded = false;
  vm.loading = false;
  vm.canDownloadDocument = userService.getUserPermission('displayDOCDownloadDocumentLink');
  vm.canEditDocument = userService.getUserPermission('displayDOCEditDocumentLink');
  vm.canDeleteDocument = userService.getUserPermission('displayDOCDeleteDocumentLink');

  // Attach Event Handlers
  vm.handleAttachDocument = _handleAttachDocument;

  function _handleAttachDocument() {
    const dfdSave = $q.defer();

    if (vm.document.attached) {
      amDataService.attachRecommendationDocument(vm.recommendationId, vm.document.documentId, vm.document.name).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been attached successfully.`);
          vm.document.recommendationDocumentId = response.data.recommendationDocumentId;
          $rootScope.$broadcast('refreshAMRecommendationDocuments', { recommendationId: vm.recommendationId });
          // ssDialogService.hide(ssDialogService.dialog.auditTrail.editRecommendationCommentDialog);
          dfdSave.resolve();
        }
      });
    } else {
      amDataService.detachRecommendationDocument(vm.document.recommendationDocumentId).then((response) => {
        if (!response.status === 200) {
          alerts.error('Error occurred while detaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been detached successfully.`);
          vm.document.recommendationDocumentId = null;
          $rootScope.$broadcast('refreshAMRecommendationDocuments', { recommendationId: vm.recommendationId });
          // ssDialogService.hide(ssDialogService.dialog.auditTrail.editRecommendationCommentDialog);
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachRecommendationDocumentController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService'
];
